// Copyright 2025, University of Maryland, All Rights Reserved
/**
 * cm-coding: Administrators compare processing volume with Jobs and Costs in
 * one operational dashboard set. This route supplies their shared background
 * and one content container, while the metrics subsystem renders the recorded
 * values; keeping the wrapper here preserves consistent alignment without
 * coupling metric cards to the application shell.
 */
import { MetricsComponent } from '@/subsystems/metrics';
import { useAuth } from '@/subsystems/workspaces';
import { apiClient } from "@/app-shell/api/api-client";

export default function Metrics() {
  const { selectedOrganizationId, selectedWorkspaceId, isGlobalAdmin } = useAuth();

  // Don't render the metrics component until we have a workspace selected and API instance
  if (!selectedOrganizationId || !selectedWorkspaceId) {
    return (
      <div className="container mx-auto px-4 py-4">
        <div className="text-center py-8">
          <p className="text-gray-600">
              Please select a workspace to view metrics.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-full bg-slate-50">
      <div className="mx-auto max-w-[1280px] px-6 pt-9 pb-16 sm:px-10">
        <MetricsComponent
          api_instance={apiClient.getAxiosInstance()}
          organization_id={selectedOrganizationId}
          workspace_id={selectedWorkspaceId}
          default_view="workspace"
          is_admin={isGlobalAdmin}
        />
      </div>
    </div>
  );
}
